import { FaBookOpen, FaCircleUser, FaDownload, FaGaugeHigh, FaListCheck, FaUserPlus, FaVideo } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const MobileSideBar = ({
  onHandleVideoModal,
  featuresRef,
  resourcesRef,
  downloadRef,
  onClose,
  isClosed,
  shouldAnimate,
  onHandleLoginModalOpen,
  technicalRoles,
}) => {
  const { isAuthenticated, role } = useAuth();

  const closeIfSelf = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  // close when any <li> clicked
  const handleListClick = (e) => {
    // Find the closest li — useful if the click is on a child element
    const li = e.target.closest("li");
    if (li) {
      onClose?.();
    }
  };

  const isAnimating = shouldAnimate ? "animate-fadeOutLeft" : "";

  return (
    <div
      className={`w-full absolute inset-0 z-50 bg-slate-200/20 backdrop-blur-sm h-screen    ${
        isClosed ? "" : "animate-fadeInLeft"
      } transition-all duration-300 ${isAnimating}`}
      onMouseDown={closeIfSelf}
    >
      <aside className="w-72 h-screen bg-white" aria-label="Sidebar">
        <div className="px-3 pb-4 pt-10 overflow-y-auto rounded bg-gray-50 h-full">
          <ul className="space-y-2" onClick={handleListClick}>
            {isAuthenticated && technicalRoles.includes(role) && (
              <li>
                <Link
                  to="/admin/dashboard"
                  className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 hover:no-underline transition-all duration-300"
                >
                  <FaGaugeHigh />
                  <span className="flex-1 ml-3 whitespace-nowrap uppercase"> Panel de Administración</span>
                </Link>
              </li>
            )}
            <li>
              <button
                onClick={() => onHandleVideoModal()}
                className="flex w-full items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:text-gray-900 hover:bg-gray-100 transition-all duration-300 "
              >
                <FaVideo />
                <span className="ml-3">VER DEMOSTRACIÓN</span>
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  featuresRef?.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }}
                className="flex w-full items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:text-gray-900 hover:bg-gray-100 transition-all duration-300 "
              >
                <FaListCheck />
                <span className="ml-3">CARACTERÍSTICAS</span>
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  resourcesRef?.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }}
                className="flex w-full items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:text-gray-900 hover:bg-gray-100 transition-all duration-300 "
              >
                <FaBookOpen />
                <span className="ml-3">MAPA DE RECURSOS</span>
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  downloadRef?.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }}
                className="flex w-full items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:text-gray-900 hover:bg-gray-100 transition-all duration-300 "
              >
                <FaDownload />
                <span className="ml-3"> DESCARGA Y CONTACTO</span>
              </button>
            </li>

            {!isAuthenticated && (
              <>
                <li>
                  <button
                    onClick={() => onHandleLoginModalOpen()}
                    className="flex w-full items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:text-gray-900 hover:bg-gray-100 transition-all duration-300 "
                  >
                    <FaCircleUser />
                    <span className="ml-3 uppercase"> Iniciar sesión</span>
                  </button>
                </li>
                <li>
                  <Link
                    to="/registro"
                    className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 hover:no-underline transition-all duration-300"
                  >
                    <FaUserPlus />
                    <span className="flex-1 ml-3 whitespace-nowrap uppercase">Registrarme</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </aside>
    </div>
  );
};

export default MobileSideBar;
